import authFetch from './fetch';
import { makeRequest, getQueryParams } from './utils';

export const routes = {

  printersPath: () => '/api/CMSv2/Printers',
  getPrintersPath: (params) => `/api/CMSv2/Printers${getQueryParams(params)}`,
  printerPath: (id) => `/api/CMSv2/Printers/${id}`,
  printersTypesPath: () => '/api/CMSv2/Printers/Types',
  restorePrinterPath: (id) => `/api/CMSv2/Printers/${id}/Restore`,
  auditsPath: (id, query) => `/api/CMSv2/Printers/${id}/Audits${getQueryParams(query)}`,
  auditsUsersPath: (id) => `/api/CMSv2/Printers/${id}/Audits/Users`,
  auditsPropertiesPath: (id) => `/api/CMSv2/Printers/${id}/Audits/Properties`,
};

export const getPrinters = (params) => makeRequest(authFetch.get(routes.getPrintersPath(params)));
export const getPrinter = (id) => makeRequest(authFetch.get(routes.printerPath(id)));
export const upsertPrinter = (printer) => makeRequest(authFetch.put(routes.printersPath(), printer));
export const getPrintersTypes = () => makeRequest(authFetch.get(routes.printersTypesPath()));
export const deletePrinter = (id) => makeRequest(authFetch.delete(routes.printerPath(id)));
export const restorePrinter = (id) => makeRequest(authFetch.patch(routes.restorePrinterPath(id)));
export const getPrinterAudit = (id, query) => makeRequest(authFetch.get(routes.auditsPath(id, query)));
export const getPrinterAuditUsers = (id) => makeRequest(authFetch.get(routes.auditsUsersPath(id)));
export const getPrinterAuditProperties = (id) => makeRequest(authFetch.get(routes.auditsPropertiesPath(id)));